// <pfs-event-bridge>: logiklose deklarative Huelle ueber liveBus.connect().
//
// Rein server-gerenderte Apps (z.B. mednet-main, Slot-System) haben keine
// eigene App-JS-Schicht und koennen liveBus.connect(url) nicht imperativ
// aufrufen — sie koennen nur ein Tag in HTML platzieren. Diese Component
// haelt fuer ihre Lebensdauer eine Live-Verbindung offen; die eigentliche
// Subscription machen die konsumierenden WCs selbst via liveBus.track().
//
// Nicht-visuell. KEINE eigene Logik — alles delegiert an liveBus. Muster
// analog <pfs-toast-host> (logikloser Drop-in-Koordinator).
//
// Attribut:
//   data-source-url   SSE-Quelle (Pflicht). Mehrfach gemountete Bridges
//                     auf dieselbe URL = idempotent (eine Verbindung).

import { defineComponent } from "../../composition/define-component.js";
import { liveBus } from "../../store/live-bus.js";
import { logger } from "../../utils/debug-logger.js";

defineComponent({
  tagName: "pfs-event-bridge",
  render(host, ctx) {
    const url = host.getAttribute("data-source-url")?.trim();
    if (!url) {
      logger.warn("pfs-event-bridge: missing data-source-url, no-op");
      return;
    }
    const release = liveBus.connect(url);
    ctx.cleanup.push(release);
  },
});
